import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/pt';

import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import InsightcareHeader from './components/InsightcareHeader';
import ProgressBar from './components/Progress';
import Loading from './components/Loading';
import PdfParecerPendente from './components/PdfParecerPendente';
import { BACKEND_URL } from './config/constants';

import AuxRoutines from './AuxRoutines';
import Select from 'react-select';
//require('moment/locale/pt-BR');

class PainelParecerPendente extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      cycle: 0,
      loading: true,
      totalCycles: 0,
      pacientes: [],
      serachPacientes: [],
      filteredPacientes: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      theme: (params.theme === 'dark' ? 'dark' : 'light'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      locationName: AuxRoutines.getLocationName(params.base, params.company),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0,
      test: '',
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
  }

  componentDidMount() {
    //Carrega o local se existe
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
    if (this.state.theme === 'dark') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredPacientes.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(200).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 20000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }

  async loadRequiredData() {
    let sliceSize = 8;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 8;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.setState({ cycle: this.state.totalCycles, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.setState({ cycle: this.state.cycle - 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

  actionPause(boolPause) {
		if (boolPause === 0) {
			this.setState({ boolPause: 1 }, () => {
				this.pauseProgress();
			});
		}
		if (boolPause === 1) {
			this.setState({ boolPause: 0 }, () => {
				this.moveProgress();
			});
		}
  }

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
    //console.log(this.state.base)
    let url = await BACKEND_URL + '/command-center/painel-parecer-pendente?base=' + this.state.base;
    if (this.state.company !== undefined && this.state.company !== 'all') {
      url = url + '&company=' + this.state.company;
    }
    let response = await axios.get(url);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ResponseData;
    }

    this.setState({
      serachPacientes: returnData,
      filteredPacientes: this.state.filteredPacientes.length !== 0 ? this.state.filteredPacientes : returnData,
    });
    return returnData;
  }

  textoGrupoPacientes(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredPacientes.length === 1) {
      return "Mostrando de 1 a 1, de 1 paciente";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 8;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 8;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " pacientes";
    }
  }

  changeTheme() {
    this.setState({ loading: true });
    this.setState(prevState => ({
      theme: prevState.theme === 'light' ? 'dark' : 'light',
    }));

    var $path = '/painel/parecer/' + this.state.base + '/' + this.state.company;

    if (this.state.theme === 'light') {
      $path = $path + '/dark';
    }
    window.location.href = $path;
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const loading = this.state.loading;
    const theme = this.state.theme;
    return (
      <div className={"App " + theme}>
        {
          loading
            ? (<Loading />)
            : (
              <div>
                <InsightcareHeader title="Monitoramento de Pareceres" theme={theme} />
                <main className={"content " + theme} id="panel1Styled">
                  <ProgressBar value={this.state.value} max={100} theme={theme} />
                  <div className={"inforow " + theme}>
                    <div className={'inforow right ' + theme}>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(0)} ><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(1)}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.actionPause(this.state.boolPause)}><img src={(this.state.boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + this.state.iconText + ".svg"} alt="" /></button>
                      <div className='infoText'>{this.textoGrupoPacientes(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
                    </div>

                    <div className={'inforow left ' + theme}>
                      <div className='infoText'>Agora são {this.state.currentDateHour}</div>
                      <PdfParecerPendente title={"Monitoramento de Pareceres"} list={(this.state.filteredPacientes.length === 0) ? this.state.serachPacientes : this.state.filteredPacientes} theme={theme} />
                      <form>
                        <div className={'buttonSearch ' + theme}>
                          <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                          <Select className={'selectSearch ' + theme}
                            placeholder="Busque por um paciente, atendimento e especialidade..."
                            options={
                              this.state.serachPacientes.map(opt => ({
                                key: opt.CODIGOATENDIMENTO + opt.DATAHORA,
                                label: opt.NOMEPACIENTE + " \n(" + opt.CODIGOATENDIMENTO.toLowerCase() + ") - " + opt.ESPECIALIDADE.toLowerCase(),
                                value: opt.CODIGOATENDIMENTO,
                                nome: opt.NOMEPACIENTE,
                                atendimento: opt.CODIGOATENDIMENTO,
                                especialidade: opt.ESPECIALIDADE,
                              }))}
                            onFocus={opt => {
                              this.actionPause(0);
                            }}
                            onBlur={opt => {
                              this.actionPause(1);
                            }}
                            isClearable={true}
                            onChange={opt => {
                              if (opt !== null && opt !== '') {
                                const pessoa = this.state.serachPacientes.find((elem) => (elem.NOMEPACIENTE === opt.nome && elem.CODIGOATENDIMENTO === opt.atendimento && elem.ESPECIALIDADE === opt.especialidade));

                                if (pessoa) {
                                  this.setState({
                                    filteredPacientes: [pessoa],
                                  });
                                } else {
                                  this.setState({
                                    filteredPacientes: this.state.serachPacientes,
                                  });
                                }
                              } else {
                                this.setState({
                                  filteredPacientes: this.state.serachPacientes,
                                });
                              }
                            }}
                          />
                        </div>
                      </form>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeTheme()}><img src={"/img/icon_theme" + this.state.iconText + ".svg"} alt="" /></button>
                    </div>
                  </div>

                  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
                    <thead>
                      <tr>
                        <th>Leito</th>
                        <th>Paciente</th>
                        <th>Convênio</th>
                        <th>Especialidade</th>
                        <th>Tempo</th>
                      </tr>
                    </thead>
                    <tbody className={theme}>
                      {
                        (this.state.filteredPacientes.length === 1
                          ? this.state.filteredPacientes
                          : this.state.pacientes)
                          .map((data) => {
                            let color = '';
                            let statusClass = "ready";
                            let tdClassFarm = "";
                            let spanClassFarm = "";
                            let name = data.NOMEPACIENTE;
                            let solicitante = data.NOMEPRESTADOR.split(' ')[0] + ' ' + data.NOMEPRESTADOR.split(' ').slice(-1).join(' ');
                            var days = 0;
                            var rdays = 0;
                            var hours = 0;
                            var rhours = 0;
                            var minutes = 0;
                            var rminutes = 0;

                            let key = "tr-" + data.CODIGOATENDIMENTO + data.DATAHORA;

                            let time = data.MINUTOSAGUARDANDO;
                            if (data.MINUTOSAGUARDANDO > 60) {
                              if (data.MINUTOSAGUARDANDO > 1440) {
                                days = (data.MINUTOSAGUARDANDO / 1440);
                                rdays = Math.floor(days);
                                hours = (days - rdays) * 24;
                                rhours = Math.floor(hours);
                                minutes = (hours - rhours) * 60;
                                rminutes = Math.round(minutes);
                                time = rdays + " d " + rhours + " h " + rminutes + " m";
                                statusClass = "canceled";
                              } else {
                                hours = (data.MINUTOSAGUARDANDO / 60);
                                rhours = Math.floor(hours);
                                minutes = (hours - rhours) * 60;
                                rminutes = Math.round(minutes);
                                time = rhours + " h " + rminutes + " m";
                                statusClass = "ready";
                              }
                            } else {
                              time = time + ' mins';
                            }
                            return (
                              <tr key={key} className={statusClass}>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='alert-content'> <div className="alert-label" /> <b>{data.LEITO}</b></td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='infoText'><b>{name}</b> | ({data.CODIGOATENDIMENTO}) </td>
                                <td style={{ color: color }} align="left">{<b>{data.CONVENIO.slice(0, 14)}</b>}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{data.ESPECIALIDADE} ({solicitante})</td>
                                <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </table>
                </main>
                <InsightcareLocalFooter hospitalName={this.state.locationName} theme={theme} />
              </div>
            )
        }
      </div>
    );
  }
}

export default PainelParecerPendente;
